import {
  GET_ADDBOOKING,
  GET_AIRPORTTERMINALLIST,
  GET_BOOKINGBUFFERTIME,
  GET_BOOKINGDETAILS,
  GET_BOOKINGLIST,
  GET_CANCELREASSON,
  GET_COMPANYCITY,
  GET_COMPANYSERVICE,
  GET_UPDATEBOOKING,
} from "resources/actionTypes";

const initialBookingListState = {
  loading: false,
  error: null,
  bookingList: "",
};

const initialBookingDetailsState = {
  loading: false,
  error: null,
  bookingDetails: "",
};

const initialAddBookingState = {
  loading: false,
  error: null,
  addBookingResponse: "",
};

const initialUpdateBookingState = {
  loading: false,
  error: null,
};

const initialCancelReasonState = {
  loading: false,
  error: null,
  cancelReason: "",
};

const initialBookingBufferTimeState = {
  loading: false,
  error: null,
  bufferTime: "",
};

const initialCompanyCityState = {
  loading: false,
  error: null,
  companyCity: "",
}

const initialCompanyServiceState = {
  loading: false,
  error: null,
  companyService: "",
}

const initialAirportTerminalsState = {
  loading: false,
  error: null,
  airportTerminalList: '',
}

export const getBookingList = (state = initialBookingListState, action) => {
  switch (action.type) {
    case GET_BOOKINGLIST.GET_BOOKINGLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKINGLIST.GET_BOOKINGLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingList: action.bookingList,
      };
    case GET_BOOKINGLIST.GET_BOOKINGLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBookingDetails = (
  state = initialBookingDetailsState,
  action
) => {
  switch (action.type) {
    case GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingDetails: action.bookingDetails,
      };
    case GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_RESET:
      return initialBookingDetailsState;
    default:
      return state;
  }
};

export const addBooking = (state = initialAddBookingState, action) => {
  switch (action.type) {
    case GET_ADDBOOKING.GET_ADDBOOKING_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDBOOKING.GET_ADDBOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        addBookingResponse: action.addBookingResponse,
      };
    case GET_ADDBOOKING.GET_ADDBOOKING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const updateBooking = (state = initialUpdateBookingState, action) => {
  switch (action.type) {
    case GET_UPDATEBOOKING.GET_UPDATEBOOKING_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEBOOKING.GET_UPDATEBOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_UPDATEBOOKING.GET_UPDATEBOOKING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getCancelReason = (state = initialCancelReasonState, action) => {
  switch (action.type) {
    case GET_CANCELREASSON.GET_CANCELREASSON_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCELREASSON.GET_CANCELREASSON_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelReason: action.cancelReason,
      };
    case GET_CANCELREASSON.GET_CANCELREASSON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBookingBufferTime = (
  state = initialBookingBufferTimeState,
  action
) => {
  switch (action.type) {
    case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_SUCCESS:
      return {
        ...state,
        loading: false,
        bufferTime: action.bufferTime,
      };
    case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getCompanyCity = (
  state = initialCompanyCityState,
  action
) => {
  switch (action.type) {
    case GET_COMPANYCITY.GET_COMPANYCITY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPANYCITY.GET_COMPANYCITY_SUCCESS:
      return {
        ...state,
        loading: false,
        companyCity: action.companyCity,
      };
    case GET_COMPANYCITY.GET_COMPANYCITY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getCompanyService = (
  state = initialCompanyServiceState,
  action
) => {
  switch (action.type) {
    case GET_COMPANYSERVICE.GET_COMPANYSERVICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPANYSERVICE.GET_COMPANYSERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        companyService: action.companyService,
      };
    case GET_COMPANYSERVICE.GET_COMPANYSERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getAirportTerminalList = (state = initialAirportTerminalsState, action) => {
  switch (action.type) {
    case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
      case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_SUCCESS:
        return {
          ...state,
          loading: false,
          airportTerminalList: action.airportTerminalsDetails,
        };
      case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
        default:
          return state;
      }
}